import './index.css';

function Loading() {
  return (
    <>
    <span class="loader"></span>
    {/* <p><strong>Loading...</strong></p> */}
    </>
  )
}

export default Loading;